import axios from "axios";
import API_URL from "@/utils/api";

const API = API_URL;

class ConfigService {
    constructor() {
        this.config = null;
        this.callbacks = [];
        this.isLoading = false;
    }

    async loadConfig() {
        if (this.config) return this.config;

        this.isLoading = true;
        try {
            const response = await axios.get(`${API}/config`);
            this.config = response.data;

            // Fallback defaults
            if (!this.config.name) this.config.name = "Conexo POS";
            if (!this.config.logo) this.config.logo = "https://conexopos.com/logo.png";

            return this.config;
        } catch (error) {
            console.error("Failed to load config", error);
            // Return safe fallback
            return {
                name: "Conexo POS",
                logo: "https://conexopos.com/logo.png",
                primary_color: "#F59E0B"
            };
        } finally {
            this.isLoading = false;
        }
    }

    getConfig() {
        return this.config || {
            name: "Conexo POS",
            logo: "https://conexopos.com/logo.png"
        };
    }
}

export const configService = new ConfigService();
